import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * Persistent entry point into Maxwell — a floating action button fixed to
 * the bottom-right corner of the viewport, mounted once at the `AppShell`
 * level (inside `MaxwellActionProvider`, above every shell branch) so it
 * appears identically regardless of which app (Sales, Global, Reports) or
 * chrome (bare launcher, present mode) is currently rendering. Maxwell's
 * actual functionality (chat/activity/inbox) is still Sales-scoped today
 * (deals/customers), but the entry point is deliberately shell-wide ahead
 * of Maxwell becoming a genuinely cross-app feature — same reasoning as
 * `MaxwellActionProvider` being hoisted above every `AppShell` branch
 * already (see `AppShell.tsx`'s doc comment on that hoist).
 *
 * Replaces the old Sales-sidebar "Maxwell" nav entry — `/maxwell`'s
 * `AppRoute` no longer sets a `section`, so it's reached only through this
 * button (plus the topbar bell → Inbox, and the rail's pop-out).
 */
export function MaxwellEntryButton() {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          to="/maxwell"
          aria-label="Maxwell"
          className="fixed bottom-5 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-raised transition-transform hover:scale-105 hover:bg-primary-hover"
        >
          <Sparkles size={20} strokeWidth={1.75} />
        </Link>
      </TooltipTrigger>
      <TooltipContent side="left">Maxwell</TooltipContent>
    </Tooltip>
  );
}
